export default __webpack_public_path__ + "static/media/ic_users.29d3b36f.svg";